<script lang="ts" setup>
import { ref } from 'vue';

const props = defineProps<{
  shouldBlur: boolean;
}>();
const revealed = ref(false);
</script>

<template>
  <span
    class="blur-field"
    :class="{ blurred: props.shouldBlur && !revealed }"
    @click="if (!revealed) revealed = true;"
  >
    <slot />
  </span>
</template>

<style scoped>
.blur-field {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
}

.blurred {
  filter: blur(5px);
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
  transition: filter 0.15s;
}

.blurred:hover {
  filter: blur(3px);
}
</style>
